export default "__VITE_ASSET__DzrV4S$f__"